import { Nullable } from 'cng-common/models/utils'
import { ConfirmationDialog } from 'partner360/components/confirmationDialog/ConfirmationDialog'

import { TRANSLATION_KEYS } from '../../../../TranslationKeys'
import { IOfferingChange } from '../../models'

interface IOfferingSwitchConfirmationProps {
  isShow: boolean
  onCancel: () => void
  onConfirm: () => void
  isDistributor: boolean
  state: Nullable<IOfferingChange>
}

export const OfferingSwitchConfirmation = ({
  isShow,
  onConfirm,
  onCancel,
  isDistributor,
  state,
}: IOfferingSwitchConfirmationProps) => {
  const postFix = state?.flag ? 'SwitchOn' : 'SwitchOff'

  return (
    <ConfirmationDialog
      title={TRANSLATION_KEYS.offerings.title}
      content={
        isDistributor
          ? TRANSLATION_KEYS.offerings[`textForDistributor${postFix}`]
          : TRANSLATION_KEYS.offerings[`text${postFix}`]
      }
      confirmBtnText={TRANSLATION_KEYS.offerings.ok}
      rejectBtnText={TRANSLATION_KEYS.offerings.cancel}
      onConfirm={onConfirm}
      onReject={onCancel}
      isVisible={isShow}
    />
  )
}
